<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'DRIVER_LIST',
    }"
  >
    <el-form
      status-icon
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      class="carpo-form demo-ruleForm"
    >
      <!-- <el-form-item :label="$t('GENDER')" prop="gender" v-loading="genderLoading">
                <el-select :disabled="ruleForm.disabled" filterable v-model="ruleForm.gender.id"
                    :placeholder="$t('SELECT_PLACEHOLDER')">
                    <el-option v-for="item in genderList" :key="item.id"
                        :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->
      <el-form-item :label="$t('FIRST_NAME')" prop="first_name">
        <el-input
          :disabled="ruleForm.disabled"
          type="text"
          v-model="ruleForm.first_name"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('LAST_NAME')" prop="last_name">
        <el-input
          :disabled="ruleForm.disabled"
          type="text"
          v-model="ruleForm.last_name"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <OrganizationalUnitSelect
        resource="driver"
        prop="organizational_unit"
        :model="ruleForm.organizational_unit"
        @update="ruleForm.organizational_unit = $event"
        :disabled="ruleForm.disabled"
      />

      <el-form-item
        class="col-span-full"
        :label="$t('description')"
        prop="description"
      >
        <el-input
          :disabled="ruleForm.disabled"
          type="textarea"
          v-model="ruleForm.description"
        ></el-input>
      </el-form-item>

      <FormConfirmation
        v-show="!ruleForm.disabled"
        @resetForm="resetForm('ruleForm')"
        @submitForm="submitForm('ruleForm')"
        :edit="null"
        :loading="submitLoading"
      />
    </el-form>
  </Content>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import OrganizationalUnitSelect from '@/components/elements/OrganizationalUnitSelect.vue'
import { driverGenders } from '@/api/drivers'
import { addDriver } from '@/api/drivers'

export default {
  mixins: [resetForm],

  components: {
    FormConfirmation,
    OrganizationalUnitSelect,
  },
  data() {
    return {
      // genderList: [],
      // genderLoading: true,
      submitLoading: false,
      ruleForm: {
        description: '',
        organizational_unit: null,
        // gender: {
        //     id: 1
        // },
        first_name: '',
        last_name: '',
      },
      rules: {
        // gender: [
        //     {
        //         required: true,
        //         trigger: "blur",
        //         message: this.$i18n.t("REQUIRED_CHOOSE", {
        //             type: this.$i18n.t("GENDER"),
        //         }),
        //     },
        // ],
        first_name: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('FIRST_NAME'),
            }),
            trigger: 'blur',
          },
        ],
        last_name: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('LAST_NAME'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            first_name: this.ruleForm.first_name,
            last_name: this.ruleForm.last_name,
            description: this.ruleForm.description,
            organizational_unit: this.ruleForm.organizational_unit,
            address: {
              country: 1,
            },
          }

          this.submitLoading = true
          addDriver.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              this.resetForm(formName)
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    driverGenders.api().then((res) => {
      if (res) {
        this.genderList = res
        this.genderLoading = false
      }
    })
  },
}
</script>
